<section class="qualification section" id="qualification">
  <h2 class="section__title">Qualification</h2>
  <span class="section__subtitle">My personal journey</span>

  <div class="qualification__container container">
    <div class="qualification__tabs">
      <div class="qualification__button button--flex" [ngClass]="{'qual': education === true}" (click)="onClickEducation()">
        <i class="uil uil-graduation-cap qualification__icon"></i>
        Education
      </div>

      <div class="qualification__button button--flex" [ngClass]="{'qual': work === true}" (click)="onClickWork()">
        <i class="uil uil-briefcase-alt qualification__icon"></i>
        Work
      </div>
    </div>

    <div class="qualification__sections">
      <!-- Qualification Content 1 -->
      <div class="qualification__content" *ngIf="education">
        <!-- Qualification 1 -->
        <div class="qualification__data">
          <div>
            <h3 class="qualification__title">High school diploma</h3>
            <span class="qualification__subtitle">Termoli - Italy</span>
            <div class="qualification__calendar">
              <i class="uil uil-calendar-alt"></i>
              2013 - 2017
            </div>
          </div>

          <div>
            <span class="qualification__rounder"></span>
            <span class="qualification__line"></span>
          </div>
        </div>

        <!-- Qualification 2 -->
        <div class="qualification__data">
          <div></div>

          <div>
            <span class="qualification__rounder"></span>
            <!-- <span class="qualification__line"></span> -->
          </div>

          <div>
            <h3 class="qualification__title">National IT Olympics</h3>
            <span class="qualification__subtitle">Termoli(CB) - Score 100/100</span>
            <div class="qualification__calendar">
              <i class="uil uil-calendar-alt"></i>
              2017
            </div>
          </div>
        </div>
      </div>

      <!-- Qualification Content 2 -->
      <div class="qualification__content" *ngIf="work">
        <!-- Qualification 1 -->
        <div class="qualification__data">
          <div>
            <h3 class="qualification__title">Hardware Technician</h3>
            <span class="qualification__subtitle">Termoli(CB) - Italy </span>
            <div class="qualification__calendar">
              <i class="uil uil-calendar-alt"></i>
              03/2017 - 04/2017
            </div>
          </div>

          <div>
            <span class="qualification__rounder"></span>
            <span class="qualification__line"></span>
          </div>
        </div>

        <!-- Qualification 2 -->
        <div class="qualification__data">
          <div></div>

          <div>
            <span class="qualification__rounder"></span>
            <span class="qualification__line"></span>
          </div>

          <div>
            <h3 class="qualification__title">Stage company</h3>
            <span class="qualification__subtitle">Afa System - Termoli(CB)</span>
            <div class="qualification__calendar">
              <i class="uil uil-calendar-alt"></i>
              02/2018 - 04/2018
            </div>
          </div>
        </div>

        <!-- Qualification 3 -->
        <div class="qualification__data">
          <div>
            <h3 class="qualification__title">Junior Frontend Developers</h3>
            <span class="qualification__subtitle">Pescara - Italy</span>
            <div class="qualification__calendar">
              <i class="uil uil-calendar-alt"></i>
              From 02/2020 Until Now
            </div>
          </div>

          <div>
            <span class="qualification__rounder"></span>
            <!-- <span class="qualification__line"></span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
